import { Alert } from 'react-bootstrap';
import { useState, useEffect } from 'react';

const BLOCK = 'LS__app_alert_react_bootstrap';

const LS = (element) => `${BLOCK}__${element}`;

/*
    🔥 ALERT — SOLO EL COMPONENTE

    El modo prueba salió de acá: vive en _DevPanel/AppDevPanel.js.
    Un alert no tiene por qué saber que existe un panel de desarrollo.
*/

// ---------------------------- 🔥 DATA
const FALLBACK = {
    type: 'info', title: 'PERRON', text: 'Mensaje de ejemplo',
    dismissible: true, autoClose: 0, // 0 = no se cierra solo. Si ponemos por ejemplo 4000 cerrará en 4 segundos
};

export const ALERT_TYPES = [
    'success', 'danger', 'warning', 'info', 'primary', 'secondary', 'light', 'dark',
];

// ---------------------------- 🔥 REAL
export const AlertReactBootstrap = ({ type, title, children, onClose, dismissible, autoClose, show }) => {

    const [useIsVisible, setIsVisible] = useState(true);

    const DELAY = autoClose ?? FALLBACK.autoClose;

    const onHandleClose = () => {
        setIsVisible(false);
        if (onClose) onClose();
    };

    useEffect(() => {
        if (!DELAY || !useIsVisible) return;
        const TIMER = setTimeout(onHandleClose, DELAY);
        return () => clearTimeout(TIMER);
    }, [DELAY, useIsVisible]);

    if (!useIsVisible || show === false) return null;

    return (
        <Alert variant={type ?? FALLBACK.type} onClose={onHandleClose} dismissible={dismissible ?? FALLBACK.dismissible}
            className={LS('alert')} >
            {
                (title ?? FALLBACK.title) && (
                    <Alert.Heading className={LS('heading')}>{title ?? FALLBACK.title}</Alert.Heading>
                )
            }
            {children ?? FALLBACK.text}
        </Alert>
    );
};
